"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _date = require("../../utils/date");
var _axios = _interopRequireDefault(require("axios"));
var _teaserSlider = _interopRequireDefault(require("./../teaser-slider"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const formatData = (data, lang, providers) => {
  const {
    items
  } = data;
  if (!items) {
    return [];
  }
  return items.map(item => {
    var _getCurrentDateTime$, _getCurrentDateTime$2;
    const {
      id,
      media = [],
      title,
      openingTimes
    } = item;
    return {
      id,
      link: "/".concat(lang, "/provider-infrastructure/").concat(id).concat(providers ? "?providers=".concat(providers) : ""),
      media,
      timeFrom: (_getCurrentDateTime$ = getCurrentDateTime(openingTimes)[0]) === null || _getCurrentDateTime$ === void 0 ? void 0 : _getCurrentDateTime$.from,
      timeTo: (_getCurrentDateTime$2 = getCurrentDateTime(openingTimes)[0]) === null || _getCurrentDateTime$2 === void 0 ? void 0 : _getCurrentDateTime$2.to,
      title
    };
  });
};
const generateDummyData = counter => {
  let items = [];
  for (let i = 0; i < counter; i++) {
    items.push({
      id: i,
      link: ""
    });
  }
  return items;
};
const getCurrentDateTime = times => {
  let newTimes = times.filter(item => {
    const {
      from,
      to
    } = item;
    return (0, _date.checkIfDateIsBetween)(from, to);
  });
  return newTimes.length ? newTimes : times;
};
const InfrastructureSlider = _ref => {
  let {
    providers,
    selected
  } = _ref;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListFacilities.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language).concat(selected ? "&selected=".concat(selected) : "");
  const {
    data: facilities,
    status
  } = (0, _reactQuery.useQuery)(["list-facilities", i18n.language, providers, selected], () => _axios.default.get(url));
  let data = generateDummyData(4);
  if (status === "success") {
    data = formatData(facilities === null || facilities === void 0 ? void 0 : facilities.data, i18n.language, providers);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 4
  }, /*#__PURE__*/_react.default.createElement(_teaserSlider.default, {
    data: data,
    lang: i18n.language,
    mediaFormat: "provider-infrastructure-teaser-slider"
  }));
};
var _default = exports.default = InfrastructureSlider;